import PatientEmail from './PatientEmail'
import PatientEvent from './PatientEvent'
import PatientProfile from './PatientProfile'
import PatientReschedule from './PatientReschedule'
// import PatientConfirm from './Patient'

export default {
	PatientEmail,
	PatientEvent,
	PatientProfile,
	PatientReschedule
}
